export const TYPO_RIF = ['V', 'E', 'J', 'G', 'P', 'C'];
export const OPERADORES = ['0412', '0422', '0414', '0424', '0416', '0426'];

// Tipos de documento para IVA
export const TIPO_DOCUMENTO = {
  FACTURA: 'factura',
  NOTA_CREDITO: 'credito',
  NOTA_DEBITO: 'debito'
};

export const CONCEPTOS = [
  { code: '001', label: 'Sueldos y salarios variable' },
  { code: '013', label: 'Centros de salud, bufetes, escritorios, oficinas, colegios (PNR)' },
  { code: '014', label: 'Venta de bienes inmuebles (PNR)' },
  { code: '015', label: 'Venta de bienes inmuebles (PJR)' },
  { code: '017', label: 'Venta de bienes inmuebles (PNR)' },
];

// Opciones para Configuración de Empresa
export const IVA_OPTIONS = [
  { value: '16,00', label: '16,00%' },
  { value: '12,00', label: '12,00%' },
  { value: '8,00', label: '8,00%' },
];

export const ISLR_OPTIONS = [
  { value: '10,00', label: '10,00%' },
  { value: '5,00', label: '5,00%' },
  { value: '3,00', label: '3,00%' },
  { value: '0,00', label: '0,00%' },
];

export const ITEMS_PER_PAGE_OPTIONS = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' }
];

/**
 * ------------------------------------------------------------------
 * Opciones de Configuración del Sistema
 * ------------------------------------------------------------------
 */

// Opciones de tema
export const THEME_OPTIONS = [
  { value: 'light', label: 'Claro' },
  { value: 'dark', label: 'Oscuro' }
];

// Opciones de formato de fecha
export const DATE_FORMAT_OPTIONS = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' }
];

// Valores por defecto de configuración
export const DEFAULT_CONFIG = {
  itemsPerPage: 10,
  dateFormat: 'DD/MM/YYYY',
  currency: 'Bs.',
  showNotifications: true,
  theme: 'light'
};